import * as React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
export default function PartnerAbschluss() {
  return <section data-section-id="155087" id="footer" className="dark bg-[#212121] text-[#EEEEEE] py-12 md:py-16">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8 mb-12">
          {}
          <Link to="/" className="inline-block">
            <img src="https://perfect-duck.10web.cloud/wp-content/uploads/2026/03/Coworking-Kassel-Logo.png" alt="BLUVIT GmbH" className="h-7 opacity-70 grayscale transition-all duration-500 hover:grayscale-0 hover:opacity-100" />
          </Link>

          {}
          <div className="flex flex-col items-start md:items-end gap-2">
            <Link to="mailto:buchung@kassel-coworking.de" className="text-lg md:text-xl font-medium text-[#EEEEEE]/70 transition-all duration-300 hover:text-[#FF6F61] hover:drop-shadow-[0_0_12px_rgba(255,111,97,0.4)]">
              buchung@kassel-coworking.de
            </Link>
            <Link to="tel:056151090993" className="text-lg md:text-xl font-medium text-[#EEEEEE]/70 transition-all duration-300 hover:text-[#FF6F61] hover:drop-shadow-[0_0_12px_rgba(255,111,97,0.4)]">
              0561 51090993
            </Link>
          </div>
        </div>

        {}
        <Separator className="bg-white/10 mb-6" />

        {}
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-[#EEEEEE]/50">
          <div className="flex flex-col items-center sm:items-start gap-1 text-center sm:text-left">
            <p>&copy; {new Date().getFullYear()} BLUVIT GmbH. Am alten Rathaus 5a 34253 Lohfelden.</p>
            <p>8-16:30 und nach Vereinbarung. Coworkingspace für Mieter 24/7 offen</p>
          </div>
          <div className="flex items-center gap-6">
            <Link to="#" className="hover:text-[#FF6F61] transition-colors duration-200">Impressum</Link>
            <Link to="https://bluvit.de/datenschutz/" newTab className="hover:text-[#FF6F61] transition-colors duration-200">
              Datenschutz
            </Link>
          </div>
        </div>
      </div>
    </section>;
}